import { ActionTypes } from "../../constants/ActionTypes";
import { IDownloadState } from "../../interfaces";

const INIT_STATE: IDownloadState = {
  base64: "",
  downloadImageLoading: false,
};


export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_DOWNLOAD_IMAGE: {
      return {
        ...state,
        base64: action.payload,
        downloadImageLoading: false,
      };
    }

    case ActionTypes.FETCH_DOWNLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        base64: "",
        downloadImageLoading: true,
      };
    }

    case ActionTypes.GET_DOWNLOAD_File: {
      return {
        ...state,
        base64: action.payload,
        downloadImageLoading: false,
      };
    }

    case ActionTypes.FETCH_DOWNLOAD_File_SUCCESS: {
      return {
        ...state,
        base64: "",
        downloadImageLoading: true,
      };
    }
    default:
      return state;
  }
};
